const cancelEvent = e => {
  // Cancel the event as stated by the standard.
  e.preventDefault();
  // Chrome requires returnValue to be set.
  e.returnValue = '';
};

export default {
  mounted() {
    this.scrollToTop();
    window.onbeforeunload = cancelEvent;
  },
  beforeDestroy() {
    window.onbeforeunload = undefined;
  },
  methods: {
    scrollToTop() {
      this.$nextTick(() => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      });
    },
  },
};
